import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import CommonTable from "../based/CommonTable";
import { IMAGEABLE_TYPE, INITPAGING, NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import CheckBox from "../based/inputs/CheckBox";
import MessPhotoServices from "../based/services/MessPhotoServices";
import AddOrEditStockModal from "./AddOrEditStockModal";
import Request from "../based/Request";

const StockPhotoModel = {
    id: 0,
    title: "",
    description: "",
    thumbUrl: "",
    width: 0,
    height: 0,
    tagConnections: [],
};

function MessengerPhoto(props) {
    const [isBusy, setIsBusy] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [msg, setMsg] = useState("Đang tải...");
    const [datas, setDatas] = useState([StockPhotoModel]);
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [isShowModal, setIsShowModal] = useState(false);
    const [selectId, setSelectId] = useState(0);
    const uploadRef = useRef(null);

    useEffect(() => {
        _getData({ ...INITPAGING, pageNumber: 1, pageSize: 100 });
    }, []);

    async function _getData(paging) {
        setIsBusy(true);
        let [err, data] = await MessPhotoServices.GetGroupDTO(paging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging(paging);
        }
        setIsBusy(false);
    }

    const _handleChecked = (index, value) => {
        let newDatas = [...datas];
        if (value) setSelectId(newDatas[index].groupId);
        else setSelectId(0);
    };

    const _handleDelete = async (id) => {
        ConfirmDialog("Xác nhận xóa?", "Xin vui lòng xác nhận để xóa ", () => {
            return new Promise(async (resolve, reject) => {
                setIsLoading(true);
                setMsg("Đang xóa dữ liệu...");
                let [error, data] = await MessPhotoServices.SetIsDeleteGroupDTO(id);
                if (!error && data) {
                    _getData(paging);
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                } else {
                    Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra trong quá trình xóa.");
                    reject({ title: "Thất bại", msg: "Vui lòng thử lại sau." });
                }
                setMsg(null);
                setIsLoading(false);
            });
        });
    };

    const handleUploadAll = (e) => {
        setIsBusy(true);
        e.preventDefault();
        let files = e.target.files;
        Request.UploadMultipleStockPhoto(files, IMAGEABLE_TYPE.StockPhoto).then((res) => {
            if (res && res.data) {
                let listImage = res.data.listImage;
                let models =
                    listImage &&
                    listImage.map((item, idx) => ({
                        name: item.fileName,
                        url: item.imageUrl,
                        thumbUrl: item.thumbnailUrl,
                    }));
                saveMultiple(models);
            }
            setIsBusy(false);
        });
    };

    const saveMultiple = async (models) => {
        const [err, data] = await MessPhotoServices.CreateMultipleGroupMess(models);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
            _getData({ ...INITPAGING, pageNumber: 1, pageSize: 100 });
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
    };

    function _renderHeader() {
        return (
            <thead>
                <tr>
                    <th className="center" width={`15%`}></th>
                    <th className="center" width={`10%`}>
                        Name
                    </th>
                    <th className="center" width={`15%`}>
                        Thumbnail
                    </th>
                    <th className="center" width={`15%`}>
                        Hành động
                    </th>
                </tr>
            </thead>
        );
    }

    function _renderAction() {
        let dataChecked = null;
        let isEnabled = false;
        if (datas && datas.length > 0) {
            dataChecked = datas.filter((x) => x.selected);
            if (dataChecked && dataChecked.length == 1) isEnabled = true;
        }
        return (
            <React.Fragment>
                <button
                    className="btn btn-custom"
                    onClick={() => {
                        setIsShowModal(true);
                        setSelectId(0);
                    }}
                >
                    Thêm mới
                </button>
                <button className={selectId > 0 ? "btn btn-danger ml-3" : "btn btn-danger ml-3 disable"} onClick={() => (selectId > 0 ? _handleDelete(selectId) : {})}>
                    Xóa
                </button>

                <button
                    className="btn btn-custom ml-3"
                    onClick={(e) => {
                        uploadRef.current.click();
                    }}
                >
                    Upload hàng loạt
                </button>

                <input
                    className="col-md-12 d-none"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                        handleUploadAll(e);
                    }}
                    multiple
                    ref={uploadRef}
                />
            </React.Fragment>
        );
    }

    function _renderBody() {
        return (
            <tbody>
                {datas && datas.length > 0 ? (
                    datas.map((item, idx) => {
                        return (
                            <tr key={idx}>
                                <td>
                                    <CheckBox id={idx.toString()} name={idx.toString()} checked={item.groupId ? item.groupId == selectId : false} label=" " onCheckedChange={(name, value) => _handleChecked(idx, value)} />
                                </td>
                                <td>{item.name}</td>
                                <td className="center">
                                    <img src={item.avatar} alt={item.name} />
                                </td>

                                <td>
                                    <button
                                        className="btn btn-custom"
                                        onClick={() => {
                                            setIsShowModal(true);
                                            setSelectId(item.groupId);
                                        }}
                                    >
                                        Chi tiết
                                    </button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={999}>Không có dữ liệu</td>
                    </tr>
                )}
            </tbody>
        );
    }

    return (
        <Wrapper>
            <Loading show={isBusy} msg="Đang tải dữ liệu..." />
            <Breadcrumbs currentPage="Quản lý Messenger Photo" />
            <CommonTable datas={datas} paging={paging} searchBasic onFilter={(paging) => _getData(paging)} renderAction={() => _renderAction()} renderHeader={() => _renderHeader()} renderBody={() => _renderBody()} />
            {isShowModal && (
                <AddOrEditStockModal
                    isShowModal={isShowModal}
                    onClose={() => {
                        setIsShowModal(false);
                        setSelectId(0);
                    }}
                    onSaveContinue={() => {
                        setIsShowModal(false);
                        _getData({ ...paging });
                    }}
                    id={selectId}
                />
            )}
        </Wrapper>
    );
}

export default MessengerPhoto;

const Wrapper = styled.div`
    .modal-class-body {
        min-height: 50vh;
    }
    td img {
        width: 80px;
        height: 80px;
        object-fit: contain;
    }
`;
